import React, { useEffect, useLayoutEffect } from "react"
import { Link } from "gatsby"

import { Container, Grid } from "@material-ui/core"

import FacebookIcon from "@material-ui/icons/Facebook"
import LinkedInIcon from "@material-ui/icons/LinkedIn"
import TwitterIcon from "@material-ui/icons/Twitter"

// import logo from "./../assets/inviz-logo.png"

export default function MobileNav() {
  /*
  const data = useStaticQuery(graphql`
    query {
      file(relativePath: { eq: "inviz-logo.png" }) {
        childImageSharp {
          fixed(width: 200, height: 200) {
            ...GatsbyImageSharpFixed
          }
        }
      }
    }
  `)
*/
  /*
  const handleMenuToggle = (e: any) => {
    if (e.target.classList.contains("open")) {
      document.body.classList.remove("menu-open")
      e.target.classList.remove("open")
    } else {
      document.body.classList.add("menu-open")
      e.target.classList.add("open")
    }
  }
*/
  const handleToggle = (e: any) => {
    if (e.target.parentElement.children[1].classList.contains("visible")) {
      e.target.parentElement.children[1].classList.remove("visible")
      e.target.classList.remove("child-open")
    } else {
      e.target.parentElement.children[1].classList.add("visible")
      e.target.classList.add("child-open")
    }
  }

  const removeToggles = () => {
    document.body.classList.remove("menu-open")
    const menuToggle = document.getElementById("menuToggle")!
    const mainMenu = document.getElementById("main__menu")!

    menuToggle.classList.remove("open")

    const x = mainMenu.querySelectorAll(".visible")
    let i = 0
    while (i < x.length) {
      x[i].classList.remove("visible")
      i++
    }
    const y = mainMenu.querySelectorAll(".child-open")
    let j = 0
    while (j < y.length) {
      y[j].classList.remove("child-open")
      j++
    }
  }
  let timer: any
  const resizeToggles = () => {
    if (timer) clearTimeout(timer)
    timer = setTimeout(() => {
      removeToggles()
    }, 300)
  }

  const handleScroll = () => {
    const scrolled = window.scrollY
    if (scrolled > 10) {
      document.body.classList.add("scrolled")
    } else {
      document.body.classList.remove("scrolled")
    }
  }

  useEffect(() => {
    window.addEventListener("resize", resizeToggles)
  })
  useLayoutEffect(() => {
    window.addEventListener("scroll", handleScroll)
  })
  return (
    <div id="footer_menu">
      <Container>
        <div className="menu">
          <div className="left">
            <ul>
              <li className="has-child">
                <span className="no-link" onClick={handleToggle}>
                  Services
                </span>
                <div>
                  <ul onClick={removeToggles}>
                    <li>
                      <Link
                        to="/services/ai-machine-learning"
                        activeClassName="active"
                      >
                        AI &amp; Machine Learning
                      </Link>
                    </li>

                    <li>
                      <Link
                        to="/services/data-management-analytics"
                        activeClassName="active"
                      >
                        Data Management &amp; Analytics
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/services/cloud-services"
                        activeClassName="active"
                      >
                        Cloud Services
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/services/application-development"
                        activeClassName="active"
                      >
                        Application Development
                      </Link>
                    </li>
                  </ul>
                </div>
              </li>
              <li className="has-child">
                <span className="no-link" onClick={handleToggle}>
                  Company
                </span>
                <div>
                  <ul onClick={removeToggles}>
                    <li>
                      <Link to="/about-us" activeClassName="active">
                        About Us
                      </Link>
                    </li>
                    <li>
                      <Link to="/our-team" activeClassName="active">
                        Our Team
                      </Link>
                    </li>
                    <li>
                      <Link to="/blog" activeClassName="active">
                        Thoughts
                      </Link>
                    </li>
                    <li>
                      <Link to="/newsroom" activeClassName="active">
                        Newsroom
                      </Link>
                    </li>
                  </ul>
                </div>
              </li>
              {/*
                <li>               
                <Link onClick={removeToggles} to="/resources" activeClassName="active">
                    Resources
                  </Link>
                </li>
                */}
              <li>
                <Link
                  onClick={removeToggles}
                  to="/careers"
                  activeClassName="active"
                >
                  Careers
                </Link>
              </li>
              <li>
                <Link
                  onClick={removeToggles}
                  to="/contact-us"
                  activeClassName="active"
                >
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>
          <div className="right social-links">
            <Grid container spacing={1} alignItems="center" wrap="nowrap">
              <Grid item></Grid>
              <Grid item>
                <a href="https://www.facebook.com/InVizAI/" target="_blank">
                  <FacebookIcon fontSize="small" />
                </a>
              </Grid>
              <Grid item>
                <a
                  href="https://www.linkedin.com/company/inviz-ai/"
                  target="_blank"
                >
                  <LinkedInIcon fontSize="small" target="_blank" />
                </a>
              </Grid>
              <Grid item>
                <a href="https://twitter.com/InViz_AI" target="_blank">
                  <TwitterIcon fontSize="small" />
                </a>
              </Grid>
            </Grid>
          </div>
        </div>
      </Container>
    </div>
  )
}
